module Cfnc {
    export class RegularExpressions {
        public static phone: RegExp = /^((\+?\d{1,3}[\s-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}(\s?(x|ex|ext)\s?\d{1,9})?)$|^(\d{10})$/;
        public static email: RegExp = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]{2,}))(:[0-9]{1,2})?$/i;
        public static password: RegExp = /^[_0-9A-Za-z]*$/;
        public static personName: RegExp = /^[a-zA-Z'\-\s\.]+$/;
        public static username: RegExp = /^[_0-9A-Za-z]*$/;
        public static postalCode: RegExp = /^([0-9]{5})(-[0-9]{4})?$/;
        public static caPostalCode: RegExp = /^[a-zA-Z][0-9][a-zA-Z]\s[0-9][a-zA-Z][0-9]$/;
        public static ssn: RegExp = /^(\d{3}-\d{2}-\d{4})$/;
        public static studentNumber: RegExp =  /^[0-9]*$/;

    }
}